import { render } from "./LoginBox.vue?vue&type=template&id=63bb9734&scoped=true"
import script from "./LoginBox.vue?vue&type=script&lang=js"
export * from "./LoginBox.vue?vue&type=script&lang=js"

import "./LoginBox.vue?vue&type=style&index=0&id=63bb9734&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bb9734"]])

export default __exports__